import { render } from "./TheNguoiDungQT.vue?vue&type=template&id=6bb1fe1e"
import script from "./TheNguoiDungQT.vue?vue&type=script&lang=js"
export * from "./TheNguoiDungQT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__